"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerMessageNoticeEventType = exports.QUIT_TYPE = void 0;
/**
 * 退出房间类型
 *
 * @export
 * @enum {number}
 */
var QUIT_TYPE;
(function (QUIT_TYPE) {
    /**
     * 不活跃踢人
     */
    QUIT_TYPE["INACTIVE"] = "INACTIVE";
    /**
     * 表示登录态失效
     */
    QUIT_TYPE["LOGIN_INVALIDATE"] = "LOGIN_INVALIDATE";
    /**
     * 表示登录限制
     */
    QUIT_TYPE["LOGIN_FORBIDDEN"] = "LOGIN_FORBIDDEN";
})(QUIT_TYPE = exports.QUIT_TYPE || (exports.QUIT_TYPE = {}));
/**
 * 推送消息事件类型
 */
var ServerMessageNoticeEventType;
(function (ServerMessageNoticeEventType) {
    /**
     * 协作人数变化
     */
    ServerMessageNoticeEventType["COLLAB_COUNT_CHANGE"] = "COLLAB_COUNT_CHANGE";
    /**
     * 文档访问有效期变化
     */
    ServerMessageNoticeEventType["EXPIRED_TIME_CHANGE"] = "EXPIRED_TIME_CHANGE";
})(ServerMessageNoticeEventType = exports.ServerMessageNoticeEventType || (exports.ServerMessageNoticeEventType = {}));
